module.exports = __webpack_public_path__ + "img/icon_home_yw03.8c4346ec.png";